<template>
  <section class="hub-request" id="resources-form">
    <div class="hub-request__info">
      <h2 class="hub-request__title" v-html="getTitleBlock(page, 'form', 'title')"></h2>
      <p class="hub-request__description" v-html="getTitleBlock(page, 'form', 'description')"></p>
      <div class="hub-request__summary">
        <b class="hub-request__summary-count">{{ selectedLabel }}</b>
        <span v-for="title in selectedTitles" :key="title" class="hub-request__summary-item">— <span v-html="title"></span></span>
        <span v-if="!selectedTitles.length" class="hub-request__summary-item" v-html="formText('empty')"></span>
      </div>
      <p class="hub-request__note" v-html="formText('note')"></p>
    </div>
    <div class="hub-request__card">
      <RequestForm />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import RequestForm from '../../request-form';
import { textBlock } from '@/entities/text-block';
import { getResourceDocumentTextGroup, RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';
import { PUBLISHED_RESOURCE_DOCUMENTS } from '@/features/agent-resources/lib';

export default {
  mixins: [ textBlock ],
  components: { RequestForm },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
      publishedCount: PUBLISHED_RESOURCE_DOCUMENTS.length,
    };
  },
  computed: {
    ...mapGetters('agentResourcesModule', ['isDocumentSelected']),
    selectedTitles() {
      return PUBLISHED_RESOURCE_DOCUMENTS
        .filter((document) => this.isDocumentSelected(document.slug))
        .map((document) => this.getKeyValueListBlockValue(this.page, getResourceDocumentTextGroup(document.id), 'title'));
    },
    selectedLabel() {
      return this.formText('selected')
        .replace('{count}', this.selectedTitles.length)
        .replace('{total}', this.publishedCount);
    },
  },
  methods: {
    formText(key) {
      return this.getKeyValueListBlockValue(this.page, 'form-details', key);
    },
  },
};
</script>

<style lang="scss" scoped>
.hub-request {
  max-width: 1328px;
  margin: 0 auto;
  padding: 120px 24px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: stretch;

  @media (max-width: 800px) {
    padding: 64px 16px 0;
  }

  &__info {
    flex: 1 1 420px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 40px;
    border-radius: 28px;
    background: #CBDDFA;

    @media (max-width: 800px) {
      padding: 24px;
    }
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(30px, 3.4vw, 44px);
    line-height: 1.15;
  }

  &__description {
    margin: 0;
    font-size: 18px;
    line-height: 26px;
    color: #4E5358;
  }

  &__summary {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px 24px;
    border-radius: 16px;
    background: #FFFFFF;
  }

  &__summary-count {
    font-size: 16px;
    font-weight: 600;
  }

  &__summary-item {
    font-size: 15px;
    line-height: 21px;
    color: #494E53;
  }

  &__note {
    margin: 0;
    font-size: 14px;
    line-height: 21px;
    color: #494E53;
  }

  &__card {
    flex: 1 1 520px;
    padding: 40px;
    border-radius: 28px;
    background: #FFFFFF;
    box-shadow: 0 8px 32px rgba(97, 113, 228, 0.08);

    @media (max-width: 800px) {
      padding: 24px;
    }
  }
}
</style>
